/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpacksamplepreview3Inputs */

const en_artifactpacksamplepreview3 = /** @type {(inputs: Artifactpacksamplepreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View a sample case file (PDF) →`)
};

const pt_artifactpacksamplepreview3 = /** @type {(inputs: Artifactpacksamplepreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver um exemplo do dossier (PDF) →`)
};

/**
* | output |
* | --- |
* | "View a sample case file (PDF) →" |
*
* @param {Artifactpacksamplepreview3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpacksamplepreview3 = /** @type {((inputs?: Artifactpacksamplepreview3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpacksamplepreview3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpacksamplepreview3(inputs)
	return pt_artifactpacksamplepreview3(inputs)
});
export { artifactpacksamplepreview3 as "artifactPackSamplePreview" }